const actions = {
  SET_STATE: 'user/SET_STATE',
  LOGIN: 'user/LOGIN',
  SSO_LOGIN: 'user/SSO_LOGIN',
  HANDOFF_LOGIN: 'user/HANDOFF_LOGIN',
  LOAD_CURRENT_ACCOUNT: 'user/LOAD_CURRENT_ACCOUNT',
  LOGOUT: 'user/LOGOUT',
  SET_ACCDETAILS: 'user/SET_ACCDETAILS',
  SET_SCOPEDETAILS: 'user/SET_SCOPEDETAILS',
  VERIFY_OTP: 'user/VERIFY_OTP',
}

export default actions
